import React, { Fragment } from "react";
import { Menu, Segment } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { IPerson } from "../../../models/IPerson";
import PersonName from "../PersonName";
import { TCertValidationFn } from "../../../hooks/usePersonCertValidator";
import { PersonCertStatus } from "../PersonCertStatus";
import { NotifyByIcon } from "./NotifyByIcon";
import { RenderCompany } from "../../companies/RenderCompany";
import { ICompany } from "../../../models/ICompany";


interface PersonSearchMenuContentProps {
    searching: boolean;
    searchError: string | undefined;
    results: IPerson[];
    onResultSelect: (id: IPerson["id"]) => void;
    onAddPerson?: () => void;
    certValidator: TCertValidationFn;
    showNotifyBy?: "phone" | "email" | "phone_and_email"
}
export const PersonSearchMenuContent: React.FC<PersonSearchMenuContentProps> = (props) => {
    const { searching, searchError, results, onResultSelect, onAddPerson, certValidator, showNotifyBy } = props;

    const t = useTranslation().t;
    const texts = {
        noResults: t("Ei tuloksia"),
        addNew: t("Lisää uusi"),
        searchError: t("Haku virhe!"),
        searching: t("Haetaan...")
    };

    return (
        <Fragment>
            {searchError && (
                <Segment basic textAlign="center">
                    <span style={{ color: "red", minWidth: "300px" }} > {texts.searchError} </span>
                </Segment>
            )}

            {searching ? (
                <Menu.Item disabled style={{ minWidth: "300px" }}> {texts.searching}  </Menu.Item>
            ) : results?.length ? (
                <Fragment>
                    {results.map((item) => {
                        const certStatus = certValidator(item.certs)
                        const notifyBy = showNotifyBy === "phone_and_email" ? (
                            item.phone?.length ? "phone" : item.email?.length ? "mail" : "none"
                        ) : showNotifyBy === "phone" ? item.phone?.length ? "phone" : "none" :
                            showNotifyBy === "email" ? (
                                item.email?.length ? "mail" : "none"
                            ) : undefined;


                        const renderPerson = (company?: ICompany) => (
                            <PersonName
                                person={item}
                                company={company}
                                showCompany
                                statusIcon={certStatus ? <PersonCertStatus status={certStatus} /> : notifyBy ? <NotifyByIcon notifyBy={notifyBy} /> : undefined}
                            />
                        );

                        return (
                            <Menu.Item
                                key={item.id}
                                onClick={() => onResultSelect(item.id)}
                                style={{ minWidth: "300px" }}
                                content={(
                                    <Fragment>
                                        {item.company ? (
                                            <RenderCompany
                                                companyId={item.company}
                                                render={({ company }) => company ? renderPerson(company) : renderPerson()}
                                            />
                                        ) : renderPerson()}

                                    </Fragment>
                                )}
                            />
                        )
                    })}
                    {onAddPerson && (
                        <Menu.Item icon="plus" content={texts.addNew} onClick={onAddPerson} />
                    )}
                </Fragment>
            ) : (
                <Fragment>
                    <Menu.Item disabled>{texts.noResults}  </Menu.Item>
                    {onAddPerson && (
                        <Menu.Item icon="plus" content={texts.addNew} onClick={onAddPerson} />
                    )}
                </Fragment>
            )
            }

        </Fragment>
    )
};


